import React from "react";
import AdminCrud from "@/components/AdminCrud";

export default function AdminTestimonials() {
  return (
    <AdminCrud
      title="Depoimentos"
      resource="testimonials"
      initialItem={{ status: "published", order: 0 }}
      fields={[
        { name: "name", label: "Nome", required: true },
        { name: "role", label: "Cargo/relação com a editora" },
        { name: "photo_url", label: "Foto", type: "image" },
        { name: "text", label: "Texto do depoimento", textarea: true, rows: 4, required: true },
        { name: "order", label: "Ordem", type: "number" },
      ]}
      columns={[
        { name: "name", label: "Nome" },
        { name: "role", label: "Cargo" },
      ]}
    />
  );
}
